module.exports = __webpack_public_path__ + "img/logo.44d79c4f.png";